import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './transfer_complete.less'
import { formatMoney } from 'client/griffin'
import StandardError from 'components/common/standard_error'
import { toCFPBStringId } from 'client/lib/cfpb'
import { trackClick } from 'lib/fpti_analytics'
import { isStage, isDev } from 'client/lib/deploy_env'

const i18n = getI18n('components/edit_glimpse/transfer')

class TransferComplete extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.number,
    currency: PropTypes.string.isRequired,
    transferError: PropTypes.any,
    onDone: PropTypes.func.isRequired,
    fromVenice: PropTypes.bool.isRequired,
    paypalDomain: PropTypes.string,
  }

  shouldComponentUpdate(nextProps, nextState) {
    // since the form this relies on might be destroyed while this transitions, we don't want to re-render if amount is non-existent.
    return nextProps.amount != null
  }

  handleFPTI = e => {
    trackClick({
      clickName: 'dw_giving_fundraiser_transfer_success_withdraw_pressed',
      data: {
        event_name: 'dw_giving_fundraiser_transfer_success_withdraw_pressed',
      },
    })
  }

  render() {
    const hostName =
      isDev() || isStage() ? location.hostname : this.props.paypalDomain
    if (this.props.transferError) {
      return <StandardError iconType="warning" title={i18n('transfer_error')} />
    }
    const withdrawlUrl = `https://${hostName}/myaccount/wallet/withdraw`
    return (
      <div>
        <span
          className="icon icon-large icon-circled-checkmark-large"
          styleName="create-indicator"
        />
        <div styleName="title">
          {i18n(toCFPBStringId('complete_title'), {
            amount: formatMoney(this.props.currency, this.props.amount),
            title: this.props.title,
          })}
        </div>
        <div styleName="sub-title">
          {i18n(toCFPBStringId('complete_sub_title'))}
        </div>
        <div styleName="actions">
          <a
            href={withdrawlUrl}
            className="vx_btn vx_btn-block vx_btn-secondary"
            onClick={this.handleFPTI}
          >
            {i18n('withdraw_to_bank')}
          </a>
        </div>
      </div>
    )
  }
}

export default cssModules(TransferComplete, styles)
